import querystring from "querystring";

import React from "react";
import { shape } from "prop-types";

import analytics from "../../utilities/analytics";
import expertProps from "../../utilities/expertProps";
import useFeatureState from "../../utilities/hooks/useFeatureState";
import DealDetails from "../DealDetails";
import * as S from "./styled";

const ExpertInfoExpanded = ({ expert }) => {
  const {
    buildingId,
    expertsApiUuid,
    listingId,
    segmentName
  } = useFeatureState();
  const profileQuery = querystring.stringify({
    bid: buildingId,
    experts_api_uuid: expertsApiUuid,
    segment: segmentName,
    ...(listingId && { sid: listingId })
  });
  const { contact } = expert;
  const profileUrl = `${contact.profile.url}?${profileQuery}`;

  const handleSendAnalyticsEvent = () => {
    analytics({
      isHdp: Boolean(listingId),
      label: `click_deals_name|expert_contact_id=${expert.contact.id}|pro=${expert.contact.is_pro}`
    });
  };

  return (
    <>
      <S.Avatar contact={contact} />
      <S.InformationSection>
        <S.NameLink
          href={profileUrl}
          onClick={handleSendAnalyticsEvent}
          target="_blank"
        >
          {contact.profile.name}
        </S.NameLink>
        <S.ProfileDetails>
          <div>{contact.business_name}</div>
        </S.ProfileDetails>
        <DealDetails expert={expert} />
      </S.InformationSection>
    </>
  );
};

ExpertInfoExpanded.propTypes = {
  expert: shape(expertProps).isRequired
};

export default ExpertInfoExpanded;
